<div class="modal-body">
  <div class="p-3">
    <h2>Available lenders</h2>
  </div>
  <div>
    <form [formGroup]="lendersForm">
      @for (lenderName of lenderNames; track lenderName) {
        <div class="d-flex align-items-center">
          <input
            type="radio"
            formControlName="lenderName"
            name="lenderName"
            class="form-check-input"
            [id]="lenderName.lenderNameId"
            [attr.data-testid]="'lender_picker_radio_' + lenderName.lenderNameId"
            [value]="lenderName.lenderNameId"
          />
          <label
            class="form-check-label lender ms-2"
            [for]="lenderName.lenderNameId"
          >
            {{ lenderName.name }}
            <img
              src="{{lenderName.lenderLogoUrl}}"
              class="logo ms-2"
            />
          </label>
        </div>
      }
    </form>
  </div>

  @if(errorMessage) {
    <div class="error-message ms-3 mt-3">{{errorMessage}}</div>
  }

  <div class="d-flex">
    <div class="col-6 d-flex flex-column btn-col p-3">
      <button
        type="button"
        class="btn btn-outline-colour-blue-600 w-100 h-100"
        (click)="applyLender()"
      >
        Continue
      </button>
    </div>
    <div class="col-6 d-flex flex-column btn-col p-3">
      <button
        type="button"
        class="btn btn-outline-colour-grayscale-900 w-100 h-100"
        (click)="cancel()"
      >
        Log out
      </button>
    </div>
  </div>
</div>
